import React from 'react'
import { Notification, Button } from 'element-react'

const NotificationSG = () => {
    const open3 = () => {
        Notification({
            title: 'Success',
            message: 'This is a success message',
            type: 'success',
        })
    }

    const open4 = () => {
        Notification({
            title: 'Warning',
            message: 'This is a warning message',
            type: 'warning',
        })
    }

    const open5 = () => {
        Notification.info({
            title: 'Info',
            message: 'This is an info message',
        })
    }

    const open6 = () => {
        Notification.error({
            title: 'Error',
            message: 'This is an error message',
        })
    }

    return (
        <div>
            <Button onClick={open3} type="success">
                Success
            </Button>
            <Button onClick={open4} type="warning">
                Warning
            </Button>
            <Button onClick={open5} type="info">
                Info
            </Button>
            <Button onClick={open6} type="danger">
                Error
            </Button>
        </div>
    )
}

export default NotificationSG
